import { Record } from 'immutable'

const NegotiationCardItemRecord = Record({
	mb_counter_price: undefined,
	original_price: '',
	product_name: '',
	user_counter_price: undefined,
	error: false,
	status: '',
})

class NegotiationCardItem extends NegotiationCardItemRecord {
	constructor(data = {}) {
		super({
			...data,
		})
	}

	update(updates) {
		return this.merge(updates)
	}
}

export default NegotiationCardItem
